module.exports = __webpack_public_path__ + "img/New PACI Flow - Enable Authentication - 12.06177cab.png";